class PopupSearch {
    constructor(item) {
        // Переменные
        this.element = item;
        this.openButtons = document.querySelectorAll('.js-popup-search-open');
        this.closeButton = this.element.querySelector('.js-popup-search-close');
        this.input = this.element.querySelector('.js-popup-search-input');
        this.placeholder = this.element.querySelector('.js-popup-search-placeholder');

        // Функции
        this.setListeners();
        this.checkInputValue()
    };

    setListeners() {
        this.openButtons.forEach(item => {
            item.addEventListener('click', () => {
                this.element.classList.toggle('is-open');

                this.popupAnime();
            });
        });

        //ToDo: сделать закрытие по esc

        this.closeButton.addEventListener('click', () => {
            this.element.classList.remove('is-open');

            this.popupAnime();
        });

        this.input.addEventListener('input', () => {
            this.checkInputValue()
        });
    }

    checkInputValue() {
        this.placeholder.style.display =  this.input.value == "" ? 'block' : 'none';
    }

    popupAnime() {
        if (this.element.style.height == 'auto') {
            this.element.style.height = `${this.element.scrollHeight}px`;
        }

        anime({
            targets: this.element,
            height: this.element.classList.contains('is-open') ? this.element.scrollHeight : 0,
            duration: 500,
            easing: 'easeInOutCirc',
            complete: () => {
                if (this.element.classList.contains('is-open')) {
                    this.element.style.height = 'auto';
                } else {
                    this.element.style.removeProperty('height');
                }
            }
        });
    }
};

document.querySelectorAll('.js-popup-search').forEach((item) => new PopupSearch(item));
